import React, { useEffect, useState } from "react";
import {
  Typography, Divider, Box, useTheme
} from '@mui/material';
import { renderToString } from "react-dom/server";

import { Alert } from "./Alert";
import videoUbicacion from "../assets/VideoUbicacion.mp4";
import { clearCacheData } from "../utils";
import { ToastNotification } from "./toastNotification";
import { useTranslation } from 'react-i18next';
import { t18 } from "i18next";

export const GeoLocationGeneric = (props) => {
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    requestLocation()
  }, []);

  useEffect(() => {
    // console.log("Recargar Geolocalizacion: ", props.ReloadGeoLocation);
    if (props.ReloadGeoLocation == true) {
      // console.log("Activa ubucacion :", props.ReloadGeoLocation);
      if (navigator.geolocation) {
        const watchId = navigator.geolocation.watchPosition(
          (position) => {
            // console.log("Activa ubucscion position:", position);
            handleGeoLocationSuccess(position);
          },
          (error) => {
            // console.error("Error al obtener la ubicación:", error.message);
            handleGeoLocationError(error);
          }
        );

        return () => {
          // console.error("navigator.geolocation.clearWatch watchId :", watchId);
          navigator.geolocation.clearWatch(watchId);
        };
      } else {
        console.error("La geolocalización no es compatible con este navegador");
      }
    }
  }, [props.ReloadGeoLocation]);

  const requestLocation = () => {
    // console.log("requestLocation browser generic.");
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        handleGeoLocationSuccess,
        handleGeoLocationError,
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
      );
    } else {
      console.log("La geolocalización no es compatible con este navegador.");
    }
  };

  const handleGeoLocationSuccess = (position) => {
    const { latitude, longitude } = position.coords;
    // console.log(
    //   "Obtiene geolocalizacion: latitude, longitude: ",
    //   latitude,
    //   longitude
    // );
    setLatitude(latitude);
    setLongitude(longitude);
    props.SuccessFN(latitude, longitude);
    setTimeout(() => {
      ToastNotification({
        icon: "success",
        text: t("location_was_obtained"),
      });
    }, 500);
  };

  const handleGeoLocationError = (error) => {
    // console.log("Error al obtener la geolocalización:", error);
    switch (error.code) {
      case error.PERMISSION_DENIED:
        // console.log("El usuario ha denegado el permiso de geolocalización.");
        Alert(
          {
            icon: "error",
            okbtntext: t("general_accept"),
            title: t("location_user_verify"),
            html: renderToString(
              <Box>
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                >
                  {t("location_user_denied")}.
                </Typography>
                <Box sx={{ width: "100%" }}>
                  <video
                    className="videoUbi"
                    src={videoUbicacion}
                    autoPlay
                    loop
                    muted
                  />
                </Box>
                <Divider sx={{ maxWidth: 300, mt: 1, mx: "auto" }} />
              </Box>
            ),
          },
          (event) => {
            // console.log("Confirmed alert: ", event);
            sessionStorage.setItem("refreshFlag", null);
            clearCacheData();
          }
        );
        props.ErrorFN(t("location_user_denied"));
        break;
      case error.POSITION_UNAVAILABLE:
        // console.log("La información de ubicación no está disponible.");
        Alert(
          {
            icon: "error",
            okbtntext: t("general_accept"),
            title: t("location_user_verify"),
            html: renderToString(
              <Box>
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                >
                  {t("location_not_available")}
                </Typography>
                <Box sx={{ width: "100%" }}>
                  <video
                    className="videoUbi"
                    src={videoUbicacion}
                    autoPlay
                    loop
                    muted
                  />
                </Box>
                <Divider sx={{ maxWidth: 300, mt: 1, mx: "auto" }} />
              </Box>
            ),
          },
          (event) => {
            // console.log("Confirmed alert: ", event);
            sessionStorage.setItem("refreshFlag", null);
            clearCacheData();
          }
        );
        props.ErrorFN(t("location_not_available"));
        break;
      case error.TIMEOUT:
        // console.log("Se ha excedido el tiempo de espera para obtener la ubicación.");
        Alert(
          {
            icon: "error",
            okbtntext: t("general_accept"),
            title: t("location_user_verify"),
            html: renderToString(
              <Box>
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                >
                  {t("location_was_expired")}
                </Typography>
                <Box sx={{ width: "100%" }}>
                  <video
                    className="videoUbi"
                    src={videoUbicacion}
                    autoPlay
                    loop
                    muted
                  />
                </Box>
                <Divider sx={{ maxWidth: 300, mt: 1, mx: "auto" }} />
              </Box>
            ),
          },
          (event) => {
            // console.log("Confirmed alert: ", event);
            sessionStorage.setItem("refreshFlag", null);
            clearCacheData();
          }
        );
        props.ErrorFN(t("location_was_expired"));
        break;
      case error.UNKNOWN_ERROR:
        // console.log("Se ha producido un error desconocido.");
        Alert(
          {
            icon: "error",
            okbtntext: t("general_accept"),
            title: t("location_user_verify"),
            html: renderToString(
              <Box>
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                >
                  {t("location_error_unknow")}
                </Typography>
                <Box sx={{ width: "100%" }}>
                  <video
                    className="videoUbi"
                    src={videoUbicacion}
                    autoPlay
                    loop
                    muted
                  />
                </Box>
                <Divider sx={{ maxWidth: 300, mt: 1, mx: "auto" }} />
              </Box>
            ),
          },
          (event) => {
            // console.log("Confirmed alert: ", event);
            sessionStorage.setItem("refreshFlag", null);
            clearCacheData();
          }
        );
        props.ErrorFN(t("location_error_unknow"));
        break;
      default:
        // console.log("No controlado: ", error);
        Alert(
          {
            icon: "error",
            okbtntext: t("general_accept"),
            title: t("location_user_verify"),
            html: renderToString(
              <Box>
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                >
                  {t("location_check_device")}
                </Typography>
                <Box sx={{ width: "100%" }}>
                  <video
                    className="videoUbi"
                    src={videoUbicacion}
                    autoPlay
                    loop
                    muted
                  />
                </Box>
                <Divider sx={{ maxWidth: 300, mt: 1, mx: "auto" }} />
              </Box>
            ),
          },
          (event) => {
            // console.log("Confirmed alert: ", event);
            sessionStorage.setItem("refreshFlag", null);
            clearCacheData();
          }
        );
        props.ErrorFN(`No controlado - Code: ${error.code}`);
        setTimeout(() => {
          requestLocation();
        }, 3000);
        break;
    }
  };

  return (
    <div style={{ display: "none" }}>
      {latitude && longitude ? (
        <p>
          Latitud: {latitude}, Longitud: {longitude}
        </p>
      ) : (
        <p>{t("location_getting")}</p>
      )}
    </div>
  );
};
